module.exports = __webpack_public_path__ + "img/PCB-quote@banner.9c7581f0.jpg";